/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import ExternalProviderPlaceholder from './ExternalProviderPlaceholder';
import { useOutletContext, Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, FormGroup, Label, Input } from 'reactstrap';
import { withLoading, useTranslator, useAppContext } from '@front-activerse/common-components';

const ExternalProvider = ({
  facebookUrl = null,
  googleUrl = null,
  appleUrl = null,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  action,
  socialBtnClassName,
  isCheckboxChecked,
}) => {
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();
  const [showModal, setShowModal] = useState(false);
  const [acceptConditions, setAcceptConditions] = useState(false);
  const [acceptConditions2, setAcceptConditions2] = useState(false);
  const [savedUrl, setSavedUrl] = useState(null);
  const [savedPlatform, setSavedPlatform] = useState(null);
  const {
    consts: { APP_BRAND },
  } = useAppContext();

  const toggle = () => {
    setShowModal(!showModal);
  };

  const handleModalBtnClick = () => {
    if (action === 'stripe') {
      // stripe register
      trackFirebaseEvent('user_action', {
        action: 'tap-stripe_signup',
        location: 'stripe_signup',
        stripe_gdpr: true,
        used_account: savedPlatform,
      });
    }
    window.location = savedUrl;
  };

  const handleSocialBtnClick = (event, url, platform) => {
    event.preventDefault();

    if (action === 'stripe') {
      // stripe register
      if (isCheckboxChecked) {
        trackFirebaseEvent('user_action', {
          action: 'tap-stripe_signup',
          location: 'stripe_signup',
          stripe_gdpr: true,
          used_account: platform,
        });

        window.location = url;
      } else {
        setShowModal(true);
        setSavedUrl(url);
        setSavedPlatform(platform);
      }
    } else if (action === 'stripe_login') {
      // stripe login
      trackFirebaseEvent('user_action', {
        action: 'tap-stripe_login',
        location: 'stripe_login ',
        used_account: platform,
      });
      window.location = url;
    } else if (action === 'cart_register' || action === 'auth_register') {
      if (isCheckboxChecked) {
        window.location = url;
      } else {
        setShowModal(true);
        setSavedUrl(url);
      }
    } else if (
      action === 'activate_product_register' ||
      action === 'activate_product_register_nutropharma'
    ) {
      if (isCheckboxChecked) {
        window.location = url;
      } else {
        setShowModal(true);
        setSavedUrl(url);
        setSavedPlatform(platform);
      }

      // old activate product register
      // if (acceptConditions) {
      //   window.location = url;
      // } else {
      //   setIsError(true);
      // }
    } else {
      // login
      window.location = url;
    }
  };

  const btnClassName = ['d-block', 'btn', 'btn-social', socialBtnClassName].join(' ');

  return (
    <>
      {displayAppleButton && appleUrl !== null ? (
        <a
          className={`${btnClassName} apple mb-m`}
          href="#"
          onClick={(event) => handleSocialBtnClick(event, appleUrl, 'apple')}
          data-test-id="apple_button"
        >
          {t('continueWithApple.button')}
        </a>
      ) : null}
      {displayGoogleButton && googleUrl !== null ? (
        <a
          className={`${btnClassName} google`}
          href="#"
          onClick={(event) => handleSocialBtnClick(event, googleUrl, 'google')}
          data-test-id="google_button"
        >
          {t('continueWithGoogle.button')}
        </a>
      ) : null}
      {displayFacebookButton && facebookUrl !== null ? (
        <a
          className={`${btnClassName} facebook mt-m`}
          href="#"
          onClick={(event) => handleSocialBtnClick(event, facebookUrl, 'facebook')}
          data-test-id="facebook_button"
        >
          {t('continueWithFacebook.button')}
        </a>
      ) : null}

      <Modal className="auth-modal" isOpen={showModal} toggle={toggle} centered size="md">
        <ModalHeader toggle={toggle} />
        <ModalBody>
          <h2 className="title-medium semi-bold">{t('acceptanceOfTermsPopup.title')}</h2>
          {APP_BRAND === 'hashimotoPl' && <p>{t('app.acceptanceOfTermsPopup.content')}</p>}

          <FormGroup check className="mb-xl">
            <Label check>
              <Input
                type="checkbox"
                name="acceptConditions"
                checked={acceptConditions}
                onChange={() => setAcceptConditions(!acceptConditions)}
              />
              {APP_BRAND === 'hashimotoPl' ? (
                <>
                  {t('auth/signup/accept-condition/1')}{' '}
                  <Link to={'/terms-of-service'}>{t('auth/signup/accept-condition/2')}</Link>{' '}
                  {t('auth/signup/accept-condition/3')}
                </>
              ) : (
                <>
                  {t('app.signUp.termsAccept.checkbox.part1')}{' '}
                  <Link to={'/terms-of-service'}>
                    {t('app.signUp.termsAccept.checkbox.termsOfServiceLink')}
                  </Link>{' '}
                  {t('app.signUp.termsAccept.checkbox.part2')}{' '}
                  <Link to={'/privacy-policy'}>
                    {t('app.signUp.termsAccept.checkbox.privacyPolicyLink')}
                  </Link>{' '}
                  {t('app.signUp.termsAccept.checkbox.part3')}
                </>
              )}
            </Label>

            {(action === 'activate_product_register' ||
              action === 'activate_product_register_nutropharma' ||
              action === 'cart_register') &&
              (APP_BRAND === 'hashimotoPl' || APP_BRAND === 'diabetesPl') && (
                <Label check className="mt-2">
                  <Input
                    type="checkbox"
                    name="acceptConditions2"
                    checked={acceptConditions2}
                    onChange={() => setAcceptConditions2(!acceptConditions2)}
                  />
                  {t('signUp.termsAccept2.checkbox')}
                </Label>
              )}
          </FormGroup>

          {APP_BRAND === 'hashimotoPl' && (
            <p className="small">
              {t('activate-product/signup/info')}{' '}
              <Link to={'/privacy-policy'}>{t('activate-product/signup/info2')}</Link>{' '}
              {t('activate-product/signup/info3')}
            </p>
          )}

          <Button
            color="primary"
            disabled={
              APP_BRAND === 'hashimotoPl' || APP_BRAND === 'diabetesPl'
                ? !acceptConditions || !acceptConditions2
                : !acceptConditions
            }
            className="w-100"
            onClick={handleModalBtnClick}
          >
            {t('acceptanceOfTermsPopup.createAccount.button')}
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
};

const Placeholder = ({
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  socialBtnClassName,
}) => (
  <ExternalProviderPlaceholder
    displayAppleButton={displayAppleButton}
    displayFacebookButton={displayFacebookButton}
    displayGoogleButton={displayGoogleButton}
    socialBtnClassName={socialBtnClassName}
  />
);

export default withLoading(ExternalProvider, Placeholder);
